<template>
  <div id="flags">
    <img class="h-4 w-5 mr-1 cursor-pointer" :class="{'flag-selected': isSelected('PtBr')}"
      src="@/assets/images/flags/br.png" alt="PtBr" @click.stop="updateLocale('PtBr')"/>
    <img class="h-4 w-5 mr-1 cursor-pointer" :class="{'flag-selected': isSelected('EnEu')}"
      src="@/assets/images/flags/en.png" alt="EnEu" @click.stop="updateLocale('EnEu')"/>
    <img class="h-4 w-5 mr-1 cursor-pointer" :class="{'flag-selected': isSelected('EsEs')}"
      src="@/assets/images/flags/es.png" alt="EsEs" @click.stop="updateLocale('EsEs')"/>
    <img class="h-4 w-5 mr-1 cursor-pointer" :class="{'flag-selected': isSelected('EsAr')}"
      src="@/assets/images/flags/ar.png" alt="EsAr" @click.stop="updateLocale('EsAr')"/>
    <img class="h-4 w-5 mr-1 cursor-pointer" :class="{'flag-selected': isSelected('PtPt')}"
      src="@/assets/images/flags/pt.png" alt="PtPt" @click.stop="updateLocale('PtPt')"/>
  </div>
</template>

<script>
import localStorageHelper from '../../helpers/local-storage-helper';
import {getLocaleCode} from "@/helpers/locale-helper";
import layoutService from '../../providers/layoutService';

export default {
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      const localeCode = getLocaleCode(locale);
      localStorageHelper.updateLocale(localeCode);
      console.log('==> localeCode: ', localeCode);
      if (this.isAuthenticated) {
        layoutService.saveLayout({language: localeCode}, new URLSearchParams());
      }
    },
    isSelected(locale) {
      return this.$i18n.locale === locale;
    }
  }
};
</script>

<style lang="scss">
#flags {
  display: flex;

  img {
    margin: 0px 5px;
  }

  // .flag-selected {

  // }
}
</style>
